import { AccessReportsWizardOption } from "@app/access-reports/shared/accessReportsWizardOption";

class AccessRadiusSearchPage {
  accessFilter: AccessReportsWizardOption;
  accessRadiusSearch: boolean;
  columns: AccessReportsWizardOption[];
  id: number;
  radiiOne: string;
  radiiTwo: string;
  radiiThree: string;
  radiiFour: string;
  radiiFive: string;
  searchByType: AccessReportsWizardOption;
  useExclusiveBands: boolean;

  constructor(accessRadiusSearch: boolean, id: number) {
    this.accessFilter = null;
    this.accessRadiusSearch = accessRadiusSearch;
    this.columns = [];
    this.id = id;
    this.radiiOne = "";
    this.radiiTwo = "";
    this.radiiThree = "";
    this.radiiFour = "";
    this.radiiFive = "";
    this.searchByType = null;
    this.useExclusiveBands = false;
  }
}

export { AccessRadiusSearchPage };
